import { Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CabinList from "pages/vending/cabin/list/CabinList";
import TrayList from "pages/vending/tray/list/TrayList";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { dispatch } from "store";
import { getCabinsByMachineThunk } from "store/reducers/vending";

const TraysAndPartition = () => {
  const { m_id } = useParams();
  const [currentCabin, setCurrentCabin] = React.useState(null);
  const [selectedItem, setSelectedItem] = React.useState(null);
  return (
    <Box padding={2}>
      <CabinList
        currentItem={currentCabin}
        setCurrentItem={setCurrentCabin}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        m_id={m_id}
      />
      {selectedItem && <TrayList cabin={selectedItem} />}
    </Box>
  );
};

export default TraysAndPartition;
